module.exports = __webpack_public_path__ + "media/3Droom.f97ec2ed.mp4";